export default __webpack_public_path__ + "static/PersonalisationText_Hover-d0a72a4aeea494b116158f1b07fbfcff.png";